import { distinctSortByTemplate } from "~/utils/array-utils";
import HeatingOilTypesData from "~/assets/data/heatingOilTypes";
import {
  DeliveryTimes,
  DeliveryTruck,
  HoseLengths,
  PaymentTypes,
  PelletProducts,
  PelletQualities,
  PelletQualityImages,
  Products,
} from "./messages";
import { DeliveryOptions } from "~/types/Profile";
import { DeliveryOptionsForDisplay } from "~/types/DeliveryOptions";

function createHeatingOilProducts(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.products,
    Object.keys(HeatingOilTypesData),
  )
    .map((e: keyof typeof HeatingOilTypesData) => {
      const data = HeatingOilTypesData[e];
      if (data) {
        const name = Products[e];
        if (name) {
          return {
            label: name,
            icon: data.icon,
            iconColor: data.iconColor,
          };
        }
      }
    })
    .filter(Boolean);
}

function createPelletProducts(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.packagings,
    Object.keys(PelletProducts),
  )
    .map((e: keyof typeof PelletProducts) => {
      return PelletProducts[e];
    })
    .filter(Boolean);
}

function createPelletQualities(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.products,
    Object.keys(PelletQualities),
  )
    .map((e: keyof typeof PelletQualities) => {
      const label = PelletQualities[e];
      if (label) {
        return {
          label,
          icon: PelletQualityImages[e as keyof typeof PelletQualityImages],
        };
      }
    })
    .filter(Boolean);
}

function createPaymentTypes(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.paymentTypes,
    Object.keys(PaymentTypes),
  )
    .map((e: keyof typeof PaymentTypes) => {
      const name = PaymentTypes[e];
      if (name) {
        return {
          label: name,
          icon: `payment-${e}.svg`,
        };
      }
    })
    .filter(Boolean);
}

function createDeliveryTimes(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.deliveryTimes,
    DeliveryTimes.map((e) => e.value),
  )
    .map((e) => DeliveryTimes.find((t) => t.value === e))
    .filter(Boolean)
    .map((e) => ({ label: e.name, icon: e.icon, iconColor: e.iconColor }));
}

function createDeliveryVehicles(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.deliveryVehicles,
    Object.keys(DeliveryTruck),
  )
    .map((e: keyof typeof DeliveryTruck) => DeliveryTruck[e])
    .filter(Boolean);
}

function createHoseLengths(deliveryOptions: DeliveryOptions) {
  return distinctSortByTemplate(
    deliveryOptions.hoseLengths,
    Object.keys(HoseLengths),
  )
    .map((e: keyof typeof HoseLengths) => HoseLengths[e])
    .filter(Boolean);
}

export function createDeliveryOptionsForDisplay(
  deliveryOptions: DeliveryOptions,
): DeliveryOptionsForDisplay {
  return {
    heatingOilProducts: createHeatingOilProducts(deliveryOptions),
    pelletProducts: createPelletProducts(deliveryOptions),
    pelletQualities: createPelletQualities(deliveryOptions),
    withDustProtection: deliveryOptions.products.includes("dustProtection"),
    paymentTypes: createPaymentTypes(deliveryOptions),
    deliveryTimes: createDeliveryTimes(deliveryOptions),
    deliveryVehicles: createDeliveryVehicles(deliveryOptions),
    hoseLengths: createHoseLengths(deliveryOptions),
    defaultDeliveryDuration: deliveryOptions.defaultDeliveryDuration,
  };
}
